import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import "./Footer.css";
import img from "./../../assets/footerbg.jpg"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowPointer, faArrowRight, faBookOpen, faBriefcase, faChalkboardTeacher, faCheckCircle, faCheckDouble, faCircle, faDotCircle, faEnvelope, faInfoCircle, faPhone, faShop, faUserShield} from '@fortawesome/free-solid-svg-icons'
function Footer() {
 
  return (
    <footer style={{ backgroundImage: `url(${img})`}}> 
      <Container fluid>
        <Row className=' p-4 text-white pt-2 footrow'>
        <Col md={5} className="d-flex flex-column mt-3">
        <h5 className='fw-bold'><span  style={{color:"#f4ae01"}}>G</span>ET IN TOUCH</h5>
        <h6 className="mt-3">SAINIK & ARDH SAINIK WELFARE DEPARTMENT</h6>
        <p style={{color:"#C1C1C1 "}}>Plot No.-100,<br/> Sainik Bhawan, <br/>Sector-12, Panchkula    (134112)</p>

         <p className=""> <FontAwesomeIcon icon={faPhone} className='me-2' style={{color:"#f3c55d"}}/><span style={{color:"#C1C1C1 "}}>0172-5210277</span></p>
              <p className=""> <FontAwesomeIcon icon={faEnvelope} className='me-2' style={{color:"#f3c55d"}} /><span style={{color:"#C1C1C1 "}}>dept.sasw-hry@gov.in</span></p>

        </Col>
        <Col md={3} className="d-flex flex-column footlink mt-3">
         <h5 className='fw-bold mb-3'><span  style={{color:"#f4ae01"}}>U</span>SEFUL LINKS</h5>
         
            <a href="#" className=' text-decoration-none footat' style={{color:"#C1C1C1 "}}><FontAwesomeIcon icon={faArrowRight} className='me-2 text-danger'/>Terms & Conditions</a>
         
          
            <a href="#"  className=' text-decoration-none footat' style={{color:"#C1C1C1 "}}><FontAwesomeIcon icon={faArrowRight} className='me-2 text-danger'/>Privacy Policy</a>
         
         
            <a href="#"  className=' text-decoration-none footat' style={{color:"#C1C1C1 "}}><FontAwesomeIcon icon={faArrowRight} className='me-2 text-danger'/>Copyright Policy</a>
          
            <a href="#"  className=' text-decoration-none footat' style={{color:"#C1C1C1 "}}><FontAwesomeIcon icon={faArrowRight} className='me-2 text-danger'/>Disclaimer</a>
          
            <a href="https://ksb.gov.in/" target="_blank" className=' text-decoration-none footat' style={{color:"#C1C1C1 "}}><FontAwesomeIcon icon={faArrowRight} className='me-2 text-danger'/>Kendriya Sainik Board</a>
            <a href="https://warb-mha.gov.in/" target="_blank" className=' text-decoration-none footat' style={{color:"#C1C1C1 "}}><FontAwesomeIcon icon={faArrowRight} className='me-2 text-danger'/>Welfare & Rehabilitation Board</a>
          
          </Col>
          
          <Col md={4} className='text-end mt-3 framemob' id='framemob'>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3431.3198617655926!2d76.85408787419043!3d30.681275288120165!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390f949d96624829%3A0x6256e334792a6931!2sDepartment%20of%20Sainik%20and%20Ardh%20Sainik%20Welfare!5e0!3m2!1sen!2sin!4v1742046259964!5m2!1sen!2sin" width="320" height="200" style={{border:'0'}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          </Col>
        </Row>
        <Row className='text-center py-2' style={{background:"rgba(0,0,0,0.3)"}}>
          <Col>
            <p className="mb-0" style={{color:"#C1C1C1", fontSize:"0.8rem"}}>
              Copyright 2024 Sainik and Ardh Sainik Welfare, Haryana. <br/>
              <span style={{fontSize:'0.7rem'}}>All Rights Reserved.</span>
              <span style={{fontSize:'0.7rem'}}> Developed by <a href="https://hkcl.in/" target='_blank' style={{fontSize:'0.7rem', color:"#f3c55d", textDecoration:"none"}}><strong>HKCL</strong></a></span>
            </p>
          </Col>
        </Row>
      </Container>
    </footer >

  );
}

export default Footer;